import React from 'react';
import {
  Chatbot,
  IngestWithContext,
  Configuration,
  type TChatConfig,
  DocumentDetailPageWithContext,
  IngestTable,
} from '@wealthlane/chatbot2';
import { axiosInstance } from '../../services/apiInterceptor';
import { useGetCurrentTenantInfo, useWealthlaneCustomerApi } from '../../hooks';
import { toast } from 'react-toastify';
import Heading from '../typography';
import { PageHeader, WrapperContainer } from '../../constants/style/common.styled';
import { ProfileContainer } from '../../pages/settings/company-profile/profile.styled';
import ToastComponent from '../toast';
import { useNavigate } from 'react-router-dom';

export const configState: TChatConfig = {
  responseProtocol: 'websocket' as const as string,
  responseType: 'stream' as const as string,
  endpoint: process.env.REACT_APP_CHATBOT_WEBSOCKET_API,
  timeout: 30000,
  ingestionEndpoint: process.env.REACT_APP_INGESTION_ENDPOINT,
  disclaimer: 'For assistance, please contact your dedicated specialist.',
};

function IngestComponent() {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: currentTenantInfo } = useGetCurrentTenantInfo(handleRequest);
  const navigate = useNavigate();

  const sendMessage = (message: string) => {
    toast.success(message);
  };

  return (
    <>
      <PageHeader>
        <Heading variant='h3' title='AI Knowledge Base Management' id='ingest' />
        <Heading variant='body-s' title='Control how the user interacts with your AI' id='ingest' />
      </PageHeader>
      <IngestWithContext
        headers={{
          url: process.env.REACT_APP_INGESTION_ENDPOINT,
          customerName: currentTenantInfo?.companyName,
          source: 'customer',
        }}
        axiosInstance={axiosInstance}
        config={configState}
        companyId={currentTenantInfo?.companyId}
        alertFunction={(message) =>
          toast.success(<ToastComponent label={'Success'} message={message} />)
        }
        metadataDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/metadata/list?status=uploaded`}
        createDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/generate-presigned-url`}
        previewDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/get-preview-presigned-url`}
        saveDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/publish`}
        documentListLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/list`}
        previewFn={(link: string) => {
          navigate(link);
        }}
      />
      <IngestTable
        headers={{
          url: process.env.REACT_APP_INGESTION_ENDPOINT,
          customerName: currentTenantInfo?.companyName,
          source: 'customer',
        }}
        axiosInstance={axiosInstance}
        config={configState}
        companyId={currentTenantInfo?.companyId}
        alertFunction={(message) =>
          toast.success(<ToastComponent label={'Success'} message={message} />)
        }
        documentListLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/list`}
      />
    </>
  );
}

function DocumentDetailComponent() {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: currentTenantInfo } = useGetCurrentTenantInfo(handleRequest);
  const navigate = useNavigate();

  return (
    <WrapperContainer data-page='documentDetail' id='pageContainer'>
      <DocumentDetailPageWithContext
        headers={{
          url: process.env.REACT_APP_INGESTION_ENDPOINT,
          customerName: currentTenantInfo?.companyName,
          source: 'customer',
        }}
        axiosInstance={axiosInstance}
        config={configState}
        companyId={currentTenantInfo?.companyId}
        chunkPreviewLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/chunks`}
        alertFunction={(message) =>
          toast.success(<ToastComponent label={'Success'} message={message} />)
        }
        goBackFn={() => navigate(-1)}
      />
    </WrapperContainer>
  );
}

export const Ingest = IngestComponent;
export const DocumentDetail = DocumentDetailComponent;
